exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.wrapper.fixed_layout .main-header {\n  position: fixed;\n  width: 100%;\n}\n.wrapper.fixed_layout .main-sidebar {\n  position: fixed;\n  height: 100vh;\n}\n@media (max-width: 767px) {\n.wrapper.hide_logo .main-header .logo {\n    display: none;\n}\n}\n.logo-mini,\n.logo-lg {\n  text-align: center;\n}\n.logo-mini img,\n.logo-lg img {\n  padding: 0.4em !important;\n}\n.logo-lg img {\n  display: -webkit-inline-box;\n  width: 25%;\n}\n.user-panel {\n  height: 4em;\n}\nhr.visible-xs-block {\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.17);\n  height: 1px;\n  border-color: transparent;\n}\n.messages-margin {\n  margin-right: 13px;\n}\n.user-menu {\n  margin-right: 30px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-521a128d","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Dash.vue
// module id = 370
// module chunks = 1